function getStairCoreCost(state, props) {
  const cost = state.stairCoreCount >= props.targetStairCoreCount ? 0 : 1e6;
  return cost;
}
export {
  getStairCoreCost
};
//# sourceMappingURL=index209.js.map
